import React from "react";
import { GlobalNav, Header, NavBar } from "../components";

import { AppSettings, ServerStaticProvider, useAppSettings } from "@skv/state";

import { compose } from "recompose";

import { withInjectedRouter, withThemeProvider } from "../hocs";
import { CountryCodeEnum } from "../types";

interface Static404Props {
  appSettings: AppSettings;
}

interface StaticLayoutProps {
  countryCode: CountryCodeEnum;
  footer: React.ReactNode;
}

export const BaseStaticLayout: React.FC<StaticLayoutProps> = ({
  countryCode,
  children,
  footer,
}) => {
  const { adminApplicationUrl } = useAppSettings();

  return (
    <>
      <div className="page-wrapper">
        <a className="sr-only sr-only-focusable" href="#content">
          Skip to main content
        </a>

        <GlobalNav countryCode={countryCode} />
        <Header adminApplicationUrl={adminApplicationUrl} />
        <NavBar>
          <NavBar.ListItem>
            <NavBar.ListItemLink to="/volunteering" data-text="Opportunities">
              Opportunities
            </NavBar.ListItemLink>
          </NavBar.ListItem>
          <NavBar.ListItem>
            <NavBar.ListItemLink to="/favourites" data-text="Favourites">
              Favourites
            </NavBar.ListItemLink>
          </NavBar.ListItem>
          <NavBar.ListItem>
            <NavBar.ListItemLink
              to="/advice-and-tips"
              data-text="Advice &amp; Tips"
            >
              Advice &amp; Tips
            </NavBar.ListItemLink>
          </NavBar.ListItem>
        </NavBar>

        <main id="content">
          <div className="container py-5">{children}</div>
        </main>
        {footer}
      </div>
    </>
  );
};

export const StaticLayout = compose<
  StaticLayoutProps & Static404Props,
  StaticLayoutProps & Static404Props
>(
  withInjectedRouter,
  withThemeProvider
)(({ appSettings, children, footer, countryCode }) => {
  return (
    <ServerStaticProvider appSettings={appSettings}>
      <BaseStaticLayout footer={footer} countryCode={countryCode}>
        {children}
      </BaseStaticLayout>
    </ServerStaticProvider>
  );
});
